import Http from "@/libs/axios";
import Vue from "vue";

export default {
  namespaced: true,
  state: {
    items: [],
    item: null,
    itemSelectOptions: [],
  },
  getters: {
    items: (state) => {
      return state.items;
    },
    itemSelectOptions: (state) => {
      return state.itemSelectOptions;
    },
  },
  mutations: {
    SET_ITEM_LIST(state, items) {
      items.data.map((item) => {
        item.OpAsPa == "Y" ? (item.OpAsPa = true) : (item.OpAsPa = false);
        item.AllowOverduePa == "Y"
          ? (item.AllowOverduePa = true)
          : (item.AllowOverduePa = false);
        item.Markpay == "Y" ? (item.Markpay = true) : (item.Markpay = false);

        return item;
      });
      state.items = items;
    },
    SET_SELECT_OPTIONS(state, { items, type }) {
      let listOfObjects = Object.keys(items).map((key) => {
        let value = items[key];
        return { value: value, text: key };
      });

      state.itemSelectOptions = [
        { value: null, text: "Please select " + (type || "council") },
        ...listOfObjects,
      ];
    },
  },
  actions: {
    getSelectOptions({ commit, dispatch }, type = "council") {
      return new Promise((resolve, reject) => {
        Http.get("council/select-options")
          .then((response) => {
            commit("SET_SELECT_OPTIONS", { items: response.data, type });
            resolve();
          })
          .catch((error) => reject(error));
      });
    },

    getList({ commit }, { params }) {
      return new Promise((resolve, reject) => {
        Http.get("council", { params: params })
          .then((response) => {
            commit("SET_ITEM_LIST", response.data);
            resolve();
          })
          .catch((error) => reject(error));
      });
    },

    show({ commit }, { id }) {
      return new Promise((resolve, reject) => {
        Http: get(`council/${id}`)
          .then((response) => {
            commit("SET_ITEM", response.data);
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },

    create({}, { payload }) {
      return new Promise((resolve, reject) => {
        payload.OpAsPa ? (payload.OpAsPa = "Y") : (payload.OpAsPa = "N");
        payload.AllowOverduePa
          ? (payload.AllowOverduePa = "Y")
          : (payload.AllowOverduePa = "N");
        payload.Markpay ? (payload.Markpay = "Y") : (payload.Markpay = "N");

        Http.post("council", payload)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },

    update({}, { payload }) {
      return new Promise((resolve, reject) => {
        payload.OpAsPa ? (payload.OpAsPa = "Y") : (payload.OpAsPa = "N");
        payload.AllowOverduePa
          ? (payload.AllowOverduePa = "Y")
          : (payload.AllowOverduePa = "N");
        payload.Markpay ? (payload.Markpay = "Y") : (payload.Markpay = "N");

        Http.put(`council/${payload.City}`, payload)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },

    destroy({}, { id }) {
      return new Promise((resolve, reject) => {
        Http.delete(`council/${id}`)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },
  },
};
